import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot,CanActivateChild } from '@angular/router';
import { PopupService } from 'src/app/core/popupmessage/popupmessage.service';
import { UserService } from '../../services/user.service';

@Injectable()
export class LoginGuard implements CanActivateChild{

    constructor( private userService:UserService, private router:Router , private popUpSrv:PopupService){}

    canActivateChild(route: ActivatedRouteSnapshot, state:RouterStateSnapshot){
        let url:string = state.url;
        console.log("Login Guard called checking active user");
        return this.checkLogin(url);
    }

    private checkLogin(url: string):boolean{
        if (this.userService.getUserName().length>0){return true}
        this.router.navigate(['./login']);
        // this.popUpSrv.ok("Not Logged In.","Show Error with option to Login","",2,true);
        return false;
    }

}